import { activities, activityParticipants } from '../activity'
import { describeTable } from './describeTable'

describeTable(activities, {
  description: `The CRM timeline: one row per event logged on an opportunity or customer (entity_type + entity_id; occasionally 'user'). Manual entries are notes, calls, emails and meetings typed by a rep; automatic entries are stage changes, task completions and "created" markers (which use type='note'). user_id is the staff author.
This is what reps chose or were prompted to log, NOT a complete record of contact: phone_calls (telephony) and emails (mail sync) hold the actual call and email logs. Use it for rep workload and lead-handling analysis, not for counting customer contacts. created_at is when the entry was logged; a meeting's actual time is scheduled_at.`,
  columns: {
    entityType:
      "'opportunity' or 'customer' (rarely 'user'). Which table entity_id points at.",
    entityId: 'Id in the table named by entity_type.',
    type: 'note = free-text note or auto "created" marker; call = a phone call the rep logged; email = an email the rep logged; meeting = a scheduled meeting (scheduled_at, duration_minutes, activity_participants); stage_change = automatic on opportunity stage moves (metadata {fromStage, toStage}); task_status = automatic when a task on the entity is completed / reopened (metadata {taskId, taskCompleted, taskTitle, assignedUserId}).',
    subject:
      'One-line headline, Finnish (e.g. "Vaihe vaihdettu: Uusi → Kontaktoitu").',
    content: 'Body text; NULL on most automatic entries.',
    userId: 'Staff member who logged it or triggered the automation.',
    metadata:
      'JSON payload by type: stage_change {fromStage, toStage}; task_status {taskId, taskCompleted, taskTitle, assignedUserId}; visit-originated entries carry {visitId}.',
    scheduledAt:
      "For type='meeting': when the meeting takes place (created_at is when it was booked).",
    durationMinutes: 'Meeting length; end = scheduled_at + this.',
  },
})

describeTable(activityParticipants, {
  description:
    'People (users, internal or external) present at a meeting activity. Being a participant does not make someone a customer member. Operational detail; rarely useful for analysis.',
})
